import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';

type UsageHistoryResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponUsageHistoryList>>;

type UsageHistoryOption = {
  couponId: number;
  filterOption: Record<string, unknown>;
  sortOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number };
};

type UsageHistoryData = {
  list: Record<string, unknown>[];
  totalCnt: number;
  summary: { totalCnt: number };
  filterOption: Record<string, unknown>;
  sortOption: Record<string, unknown>;
  pagination: { pageNum: number; pageSize: number; pages: number; totalCnt: number };
};

export const useCouponUsageHistoryQuery = (
  option: UsageHistoryOption,
  options?: UseQueryOptions<UsageHistoryResponse, AxiosError, UsageHistoryData>,
): UseQueryResult<UsageHistoryData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponUsageHistory(option.couponId, option),
    () => CouponApiV2.getCouponUsageHistoryList(option),
    {
      select: (res: UsageHistoryResponse) => {
        const totalCnt = res.data.totalCnt ?? 0;
        return {
          list: res.data.couponUsageHistoryList ?? [],
          totalCnt,
          summary: { totalCnt },
          filterOption: option.filterOption,
          sortOption: option.sortOption,
          pagination: {
            pageNum: option.pagination.pageNum,
            pageSize: option.pagination.pageSize,
            pages: Math.ceil(totalCnt / Math.max(1, option.pagination.pageSize)) || 1,
            totalCnt,
          },
        };
      },
      enabled: !!option.couponId,
      ...options,
    },
  );
};
